import React, { useState, useEffect } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import './DynamicCheckBoxGroup.css';  // Import custom CSS

interface DynamicCheckboxGroupProps {
  options: string[];
  selectedValues: string[];
  onSelectionChange: (selected: string[]) => void;
}

const DynamicCheckboxGroup: React.FC<DynamicCheckboxGroupProps> = ({ options, selectedValues, onSelectionChange }) => {
  const [selectedOptions, setSelectedOptions] = useState<Record<string, boolean>>({});

  // Initialize the selectedOptions state based on options and selectedValues props
  useEffect(() => {
    const initialSelectedOptions = options.reduce((acc, option) => {
      acc[option] = selectedValues.includes(option);
      return acc;
    }, {} as Record<string, boolean>);
    setSelectedOptions(initialSelectedOptions);
  }, [options, selectedValues]);

  // Handle checkbox state change
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    setSelectedOptions((prevState) => {
      const updatedSelectedOptions = {
        ...prevState,
        [name]: checked,
      };

      // Trigger the onSelectionChange callback with the updated selected options
      const checkedOptions = Object.keys(updatedSelectedOptions).filter((key) => updatedSelectedOptions[key]);
      onSelectionChange(checkedOptions);

      return updatedSelectedOptions;
    });
  };

  return (
    <div> {/* Changed from <Form> to <div> */}
      <Form.Group as={Row} className="mb-3 align-items-center align-middle">
        <Form.Label as="legend" className="d-flex fw-bolder align-items-center">
          {'Contact Type'.toTranslatedDisplay()}
          <i className="bi bi-info-circle ms-1"></i>
        </Form.Label>
        <Col sm={10} className="d-flex align-items-center">
          {options.map((option, index) => (
            <Form.Check 
              key={option}
              inline 
              type="checkbox"
              label={option.toTranslatedDisplay()}
              name={option} 
              checked={selectedOptions[option] || false}  // Ensure the checkbox is always controlled
              onChange={handleCheckboxChange} 
              className="custom-checkbox"
              tabIndex={index + 1}
            />
          ))}
        </Col>
      </Form.Group>
    </div>
  );
};

export default DynamicCheckboxGroup;
